import React from 'react';
import { ArrowRight, Play } from 'lucide-react';
import { Button } from './ui/button';
import { heroData } from '../data/mockData';

const Hero = () => {
  return (
    <section className="min-h-screen flex items-center pt-20 md:pt-0 bg-[#0a0a0a]">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div className="order-2 lg:order-1">
            <span className="inline-block text-sm font-medium text-[#c9a962] tracking-wider uppercase mb-6">
              Content Creator & Social Media Manager • London
            </span>
            
            <h1 className="hero-large text-white mb-6 leading-tight">
              {heroData.headline}
            </h1>
            
            <p className="body-large text-[#b3b3b3] mb-8 max-w-lg leading-relaxed">
              {heroData.subheadline}
            </p>
            
            {/* Trust indicator */}
            <div className="flex items-center gap-3 mb-10">
              <div className="flex -space-x-2">
                <div className="w-8 h-8 rounded-full bg-[#c9a962]/20 border-2 border-[#0a0a0a] flex items-center justify-center">
                  <span className="text-xs text-[#c9a962]">★</span>
                </div>
                <div className="w-8 h-8 rounded-full bg-[#c9a962]/20 border-2 border-[#0a0a0a] flex items-center justify-center">
                  <span className="text-xs text-[#c9a962]">★</span>
                </div>
                <div className="w-8 h-8 rounded-full bg-[#c9a962]/20 border-2 border-[#0a0a0a] flex items-center justify-center">
                  <span className="text-xs text-[#c9a962]">★</span>
                </div>
              </div>
              <span className="text-sm text-[#808080]">Trusted by 30+ businesses in London</span>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                asChild
                className="bg-[#c9a962] text-[#0a0a0a] hover:bg-[#d4b978] border-none rounded-none px-8 py-4 h-auto text-sm font-medium transition-all duration-300"
              >
                <a href="#portfolio" className="inline-flex items-center gap-2">
                  View My Work
                  <ArrowRight size={16} />
                </a>
              </Button>
              
              <Button 
                asChild
                variant="outline"
                className="bg-transparent text-[#c9a962] border border-[#c9a962] hover:bg-[#c9a962] hover:text-[#0a0a0a] rounded-none px-8 py-4 h-auto text-sm font-medium transition-all duration-300"
              >
                <a href="#contact">Let's Work Together</a>
              </Button>
            </div>
          </div>
          
          {/* Image */}
          <div className="order-1 lg:order-2">
            <div className="relative">
              <div className="aspect-[4/5] lg:aspect-[3/4] overflow-hidden">
                <img 
                  src="https://customer-assets.emergentagent.com/job_visuals-by-kate/artifacts/yyd0ndku_IMG_4263.jpeg" 
                  alt="Kate Samuilova - Content Creator"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Decorative Elements */}
              <div className="absolute -bottom-4 -left-4 w-24 h-24 border border-[#c9a962]/50 -z-10" />
              <div className="absolute -top-4 -right-4 w-16 h-16 border border-[#c9a962]/30 -z-10" />
              
              {/* Floating badge */}
              <div className="absolute bottom-6 right-6 bg-[#0a0a0a]/90 backdrop-blur-sm border border-[#2a2a2a] px-4 py-3">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-[#c9a962] rounded-full animate-pulse" />
                  <span className="text-sm text-white">Available for projects</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
